import { IGameAttendancesVotes } from "@grassrootly/api/entities/IGameAttendancesVotes";
import { provider } from "@grassrootly/api/providers";

export type GetPlayerGameVotesPayload = {
  gameId: number;
  id: number;
};

export const GetPlayerGameVotes = async (params: GetPlayerGameVotesPayload): Promise<IGameAttendancesVotes[]> =>
  provider.Request("/players/{id}/games/{gameId}/votes", params);
